var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TableColumn_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { tableColumnSchemaValidation } from '../validations.generated';
export var NumericFormatTypes;
(function (NumericFormatTypes) {
    NumericFormatTypes["Percent"] = "percent";
    NumericFormatTypes["Dollar"] = "dollar";
})(NumericFormatTypes || (NumericFormatTypes = {}));
export var ConditionSymbolTypes;
(function (ConditionSymbolTypes) {
    ConditionSymbolTypes["Equal"] = "equal";
    ConditionSymbolTypes["NotEqual"] = "not_equal";
    ConditionSymbolTypes["Less"] = "less";
    ConditionSymbolTypes["LessOrEqual"] = "less_or_equal";
    ConditionSymbolTypes["Greater"] = "greater";
    ConditionSymbolTypes["GreaterOrEqual"] = "greater_or_equal";
})(ConditionSymbolTypes || (ConditionSymbolTypes = {}));
export var DateFormat;
(function (DateFormat) {
    DateFormat["FullDateAndTime"] = "fullDateAndTime";
    DateFormat["LongDate"] = "longDate";
    DateFormat["ShortDate"] = "shortDate";
    DateFormat["Time"] = "time";
    DateFormat["ShortMonth"] = "shortMonth";
    DateFormat["None"] = "none";
})(DateFormat || (DateFormat = {}));
export var ConditionLogicTypes;
(function (ConditionLogicTypes) {
    ConditionLogicTypes["And"] = "and";
    ConditionLogicTypes["Or"] = "or";
})(ConditionLogicTypes || (ConditionLogicTypes = {}));
export const tableColumnSchema = {
    $id: 'urn:wisepipe-common-computation:TableColumn',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        width: { type: 'number', minimum: 0 },
        numericFormat: {
            type: 'object',
            properties: {
                type: { type: 'string', enum: Object.values(NumericFormatTypes) },
                decimals: { type: 'number', minimum: 0, maximum: 14 },
                thousandSeparator: { type: 'boolean' }
            },
            anyOf: [{ required: ['type'] }, { required: ['decimals'] }, { required: ['thousandSeparator'] }]
        },
        format: {
            type: 'object',
            properties: {
                backgroundColor: { type: 'string', minLength: 1 },
                fontColor: { type: 'string', minLength: 1 },
                bold: { type: 'number', minimum: 0 },
                italics: { type: 'boolean' },
                underline: { type: 'boolean' },
                fontSize: { type: 'number', minimum: 0 }
            },
            anyOf: [
                { required: ['backgroundColor'] },
                { required: ['fontColor'] },
                { required: ['bold'] },
                { required: ['italics'] },
                { required: ['underline'] },
                { required: ['fontSize'] }
            ]
        },
        conditionalFormat: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    symbol: { type: 'string', minLength: 1 },
                    value: { type: 'number' },
                    logic: { type: 'string' },
                    logicSymbol: { type: 'string', minLength: 0 },
                    logicValue: { type: 'number' },
                    format: {
                        type: 'object',
                        properties: {
                            backgroundColor: { type: 'string', minLength: 1 },
                            fontColor: { type: 'string', minLength: 1 },
                            bold: { type: 'number', minimum: 0 },
                            italics: { type: 'boolean' },
                            underline: { type: 'boolean' },
                            fontSize: { type: 'number', minimum: 0 }
                        },
                        anyOf: [
                            { required: ['backgroundColor'] },
                            { required: ['fontColor'] },
                            { required: ['bold'] },
                            { required: ['italics'] },
                            { required: ['underline'] },
                            { required: ['fontSize'] }
                        ]
                    }
                },
                anyOf: [{ required: ['symbol'] }, { required: ['value'] }]
            }
        },
        dateFormat: {
            type: 'string',
            enum: Object.values(DateFormat)
        }
    },
    required: ['name']
};
let TableColumn = TableColumn_1 = class TableColumn {
    constructor(name, width, numericFormat, format, conditionalFormat, dateFormat) {
        this.name = name;
        if (width !== undefined)
            this.width = width;
        if (numericFormat !== undefined)
            this.numericFormat = numericFormat;
        if (format !== undefined)
            this.format = format;
        if (conditionalFormat?.length)
            this.conditionalFormat = conditionalFormat;
        if (dateFormat !== undefined)
            this.dateFormat = dateFormat;
        JSON.validate(this, TableColumn_1);
    }
};
TableColumn = TableColumn_1 = __decorate([
    JsonSchemaV2(tableColumnSchema, tableColumnSchemaValidation)
], TableColumn);
export { TableColumn };
//# sourceMappingURL=tableColumn.js.map